import moment from 'moment';
import 'moment-timezone';

moment.tz.link(['America/Los_Angeles|US/Pacific', 'America/New_York|US/Eastern']);
